import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHarmonyComplementary = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5M12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5M12 12.5V18.5M12 11.5V5.5M12 5.5C12.7815 5.5 13.4234 4.90236 13.4936 4.13919M12 5.5C11.2185 5.5 10.5766 4.90236 10.5064 4.13919M10.5064 19.8608C10.5022 19.9066 10.5 19.9531 10.5 20C10.5 20.8284 11.1716 21.5 12 21.5C12.8284 21.5 13.5 20.8284 13.5 20C13.5 19.9531 13.4978 19.9066 13.4936 19.8608C13.4234 19.0976 12.7815 18.5 12 18.5M12 18.5C11.2185 18.5 10.5766 19.0976 10.5064 19.8608M13.4936 4.13919C13.4978 4.09336 13.5 4.04693 13.5 4C13.5 3.17157 12.8284 2.5 12 2.5C11.1716 2.5 10.5 3.17157 10.5 4C10.5 4.04693 10.5022 4.09336 10.5064 4.13919M13.4936 4.13919C17.1981 4.83877 20 8.09217 20 12C20 15.9078 17.1981 19.1612 13.4936 19.8608M10.5064 4.13919C6.80192 4.83877 4 8.09217 4 12C4 15.9078 6.80192 19.1612 10.5064 19.8608",
		stroke: "#f0f0f0"
	})
});
export default SvgHarmonyComplementary;
